import { useMemo } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { makeSelectModalStateById } from '../store/ui-slice';

const useModalState = (modalId: string) => {
  const selectModalStateById = useMemo(makeSelectModalStateById, []);
  const modalState = useAppSelector(state => selectModalStateById(state, modalId));

  return [!!modalState, typeof modalState !== 'boolean' ? modalState : undefined] as const;
};

export default useModalState;
